export default __webpack_public_path__ + "static/media/Guru-Parampara-24.ceae7059.png";